module.exports = __webpack_public_path__ + "static/media/5.258569d4.jpg";